import script from "./PowerBI.vue?vue&type=script&setup=true&lang=ts"
export * from "./PowerBI.vue?vue&type=script&setup=true&lang=ts"

import "./PowerBI.vue?vue&type=style&index=0&id=6535568e&lang=css"

const __exports__ = script;

export default __exports__